import React, { Component } from "react";
import Img404 from "../../components/backend/assets/images/404.png";

class Forbidden extends Component {
  render() {
    return (
      <>
        <div className="maintenance-block">
          <div className="container">
            <div className="row justify-content-center" style={{ marginTop: "120px" }}>
              <div className="col-md-12">
                <div className="card error-card" style={{ marginLeft: "250px" }}>
                  <div className="card-body">
                    <div className="error-image-block">
                      <img className="img-fluid" src={Img404} alt="Not Found" />
                    </div>
                    <div className="text-center">
                      <h1 className="mt-3"><b>Oops! Page not found!</b></h1>
                      <p className="mt-2 mb-4 text-muted">
                        The page you are looking was moved, removed,<br />renamed, or might never exist!
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Forbidden;
